module.exports = __webpack_public_path__ + "img/products-4@2x.af952dc.jpg";